// extracted by mini-css-extract-plugin
module.exports = {"container":"CountDown_container__2XZkU","table":"CountDown_table__3M946","row":"CountDown_row__2JTl2","cell":"CountDown_cell__2iYXr"};